<template>
  <div class="hello">
    <div id="header" v-show="displayHeader" v-cloak>
     <h1>დასუფთავების მოსაკრებელი</h1>
      <h2>{{municipaliteti}}</h2>
      <button @click="printWindow">დაბეჭდვა</button>
      </div>
    <div id="printingArea">
       <table class="a3rdframe" v-for="(abonenti, index) in abonentebi">
       <tr><td colspan="3">{{khazina.biujShemosCodi}}</td></tr>
       <tr><td colspan="3">{{municipaliteti}}</td></tr>
         
         <tr><td colspan="3">{{mosakrebeli}}</td></tr>
         <tr><td colspan="3">{{kvitari}}{{index+1}}</td></tr>
         <tr><td colspan="3">{{abonenti.saxeli}}</td></tr>
         <tr><td colspan="3">{{lokacia}}</td></tr>
         <tr><td colspan="3">{{abonenti.abonentiN}}</td></tr>
         <tr><td>{{gadasaxdPeriodi}}</td> <td>{{zomErteuli}}</td> <td>{{gadasZomis1Ert}}</td></tr>
         <tr><td>{{abonenti.daricxva.dro}}</td><td>{{zomErteuliKvM}}</td><td>{{abonenti.daricxva.tarifi1Erteulze}}</td></tr>
         <tr><td colspan="2">{{gadasaxdeliTanxa}}</td> <td>{{abonenti.daricxva.gadasaxdeliTanxaV}}</td></tr>
         <tr><td colspan="2">{{tsinaDavalianeba}}</td><td>{{abonenti.daricxva.tsinaDavalianebaV}}</td></tr>
         <tr><td colspan="2">{{gadaxdTanxa}}</td><td>{{abonenti.daricxva.gadaxdTanxaV}}</td></tr>
         <tr><td colspan="2">{{mimdinareGadasaxdeli}}</td><td>{{abonenti.daricxva.mimdinareGadasaxdeliV}}</td></tr>
         <tr><td colspan="3">{{infoMosakrebeli}}</td></tr>
         <tr><td colspan="3">{{khazina.rekvizitebi}}</td></tr>
         <tr><td colspan="3">{{khazina.khazErtAngarishi}}</td></tr>
         <tr><td colspan="3">{{khazina.sakhKhazBankKodi}}</td></tr>
         <tr><td colspan="3">{{khazina.biujShemosCodi}}</td></tr>
       </table>
       </div>
   
    

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      displayHeader: true,
      municipaliteti: 'თიანეთის მუნიციპალიტეტი',
      mosakrebeli: 'დასუფთავების მოსაკრებელი',
      lokacia: 'დაბა თიანეთი',
      infoMosakrebeli: 'გთხოვთ მოსაკრებელი გადაიხადოთ არა უგვიანეს 20 რიცხვისა',
      gadasaxdeliTanxa: 'გადასახდელი თანხა თვეში',
      tsinaDavalianeba: 'წინა დავალიანება',
      gadaxdTanxa: 'გადახდილი თანხა',
      mimdinareGadasaxdeli: 'სულ მიმდინარე გადასახადი',
      gadasaxdPeriodi: 'გადასახდელი პერიოდი 2020 წ',
      zomErteuli: 'ზომის ერთეული',
      zomErteuliKvM: 'კვ.მ',
      gadasZomis1Ert: 'გადასახადი ზომის 1 ერთეულზე',
      kvitari: 'ქვითარი N',
      khazina: {
        rekvizitebi: 'სახაზინო რეკვიზიტები',
        khazErtAngarishi: 'ხაზინის ერთიანი ანგარიში ა/ა 200122900',
        sakhKhazBankKodi: 'სახელმწიფო ხაზინა ბანკის კოდი 220101222',
        biujShemosCodi: 'ბიუჯეტის შემოსულობების კოდი 300143189',
      },
      abonentebi: [ {
        saidentifikacKodi: 44556778,
        saxeli: 'შპს ბაჩო',
        abonentiN: 'აბონენტი N 129',
        daricxva: {
          dro: 'სექტემბერი-ოქტომბერი',
          farti: 70,
          tarifi1Erteulze: 0.41,
          gadasaxdeliTanxaV: 28.7,
          tsinaDavalianebaV: 516.6,
          gadaxdTanxaV: 0,
          mimdinareGadasaxdeliV: 545.3
        }
              },
        {
 
        saidentifikacKodi: 44556778,
        saxeli: 'ი/მ თეიმურაზ ქავთარაძე',
        abonentiN: 'აბონენტი N 118',
        daricxva: {       
          dro: 'სექტემბერი-ოქტომბერი',
          farti: 20,
          tarifi1Erteulze: 0.31,
          gadasaxdeliTanxaV: 6.2,
          tsinaDavalianebaV: 489.8,
          gadaxdTanxaV: 0,
          mimdinareGadasaxdeliV: 496
          }
 
              },
        {
 
        saidentifikacKodi: 44556778,
        saxeli: 'ი/მ მაყვალა ბერიკიშვილი',
        abonentiN: 'აბონენტი N 100',
        daricxva: {       
               dro: 'სექტემბერი-ოქტომბერი',
            farti: 38.128,
            tarifi1Erteulze: 0.08,
            gadasaxdeliTanxaV: 3.05,
            tsinaDavalianebaV: 34.1,
            gadaxdTanxaV: 0,
            mimdinareGadasaxdeliV: 37.15
            }
        },
        {
 
        saidentifikacKodi: 44556778,
        saxeli: 'ი/მ მაყვალა ბერიკიშვილი',
        abonentiN: 'აბონენტი N 100',
        daricxva: {       
               dro: 'სექტემბერი-ოქტომბერი',
            farti: 38.128,
            tarifi1Erteulze: 0.08,
            gadasaxdeliTanxaV: 3.05,
            tsinaDavalianebaV: 34.1,
            gadaxdTanxaV: 0,
            mimdinareGadasaxdeliV: 37.15
            }
        },
        {
        saidentifikacKodi: 44556778,
        saxeli: 'შპს ბაჩო',
        abonentiN: 'აბონენტი N 129',
        daricxva: {
          dro: 'სექტემბერი-ოქტომბერი',
          farti: 70,
          tarifi1Erteulze: 0.41,
          gadasaxdeliTanxaV: 28.7,
          tsinaDavalianebaV: 516.6,
          gadaxdTanxaV: 0,
          mimdinareGadasaxdeliV: 545.3
        }
              },
        {
 
        saidentifikacKodi: 44556778,
        saxeli: 'ი/მ თეიმურაზ ქავთარაძე',
        abonentiN: 'აბონენტი N 118',
        daricxva: {       
          dro: 'სექტემბერი-ოქტომბერი',
          farti: 20,
          tarifi1Erteulze: 0.31,
          gadasaxdeliTanxaV: 6.2,
          tsinaDavalianebaV: 489.8,
          gadaxdTanxaV: 0,
          mimdinareGadasaxdeliV: 496
          }
 
              },
              
      ]


    }
  },
  methods:{
    printWindow: function () {		
         
        this.displayHeader= false
      // first change than print
       this.$nextTick(() => {
          window.print();
        });
          
    }
  },
     


  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.frame {
     border: 1px solid black;


}
 .a4frame{
   width: 297mm;
   height: 210mm;
   margin: 10px auto;
   box-sizing: border-box;
 }
 .a3rdframe{
   width: 92mm;
   height: 200mm;
   margin: 18px 8px;
   box-sizing: border-box;
   display: inline-block
 }
 h1{
   text-align: center;
 }
 table {
  border-collapse: collapse;
}

 th, td {
  border: 1px solid black;
}


 td{
   font-size: 14px;
   line-height: 33px;
 }

 .marcx-saxadi{
   width: 50mm;
 
 }
 .marjv-saxadi{
   width: 42mm;

 }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue